import msalAuthHandler from "vue-msal-wrapper";

export const BackendAuth = {
  install(Vue, router, opts = {}) {
    Vue.prototype.$backend = msalAuthHandler.authenticatedApi(
      "",
      "login"
    );
  },
};